import type { PillBadgeVisualization } from '../../types';

interface PillBadgeRendererProps {
    data: PillBadgeVisualization;
    className?: string;
}

/**
 * Renders a PillBadge visualization as inline rounded chips.
 */
export function PillBadgeRenderer({ data, className }: PillBadgeRendererProps) {
    return (
        <div className={`weavable-pill-badge ${className || ''}`.trim()}>
            {data.pills.map((pill, index) => (
                <span
                    key={`${index}-${pill.label}`}
                    className="weavable-pill-badge__item"
                    style={pill.color ? { backgroundColor: pill.color } : undefined}
                >
                    {pill.label}
                </span>
            ))}
        </div>
    );
}
